/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EntityActivityKind = "EDUCATIONAL" | "GOVERNMENT_AGENCY" | "NON_PROFIT" | "PARTNERSHIP" | "PRIVATELY_HELD" | "PUBLIC_COMPANY" | "SELF_EMPLOYED" | "SELF_OWNED" | "%future added value";
export type EventStatusKind = "canceled" | "completed" | "draft" | "ended" | "live" | "started" | "%future added value";
export type MediaAssetFileStatusKind = "AVAILABLE" | "CREATED" | "DELETED" | "ERROR" | "PROCESSING" | "%future added value";
export type MediaAssetStateKind = "AVAILABLE" | "CREATED" | "DELETED" | "PROCESSING" | "%future added value";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type listCollectionQueryVariables = {
    readonly listCollectionId: string;
    readonly count?: number | null;
};
export type listCollectionQueryResponse = {
    readonly listCollection: {
        readonly errors: ReadonlyArray<{
            readonly created: unknown | null;
            readonly id: string;
            readonly location: string | null;
            readonly type: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
        readonly listCollection: {
            readonly description: string | null;
            readonly id: string;
            readonly label: string | null;
            readonly badges: ReadonlyArray<{
                readonly imageLink: string | null;
                readonly link: string | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
            }> | null;
            readonly lists: ReadonlyArray<{
                readonly __typename: string;
                readonly description?: string | null;
                readonly id?: string;
                readonly items?: {
                    readonly pageInfo: {
                        readonly hasNextPage: boolean | null;
                    } | null;
                    readonly edges: ReadonlyArray<{
                        readonly listItem: {
                            readonly item: ({
                                readonly __typename: string;
                                readonly id?: string;
                                readonly name?: string | null;
                                readonly description?: string | null;
                                readonly end?: unknown | null;
                                readonly start?: unknown | null;
                                readonly status?: EventStatusKind | null;
                                readonly externalId?: string | null;
                                readonly created?: unknown | null;
                                readonly previews?: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                                readonly people?: ReadonlyArray<{
                                    readonly id: string;
                                    readonly fullName: string | null;
                                    readonly responsibility: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly count: number | null;
                                        readonly edges: ReadonlyArray<{
                                            readonly cursor: string | null;
                                            readonly preview: {
                                                readonly mediaAsset: {
                                                    readonly id: string;
                                                    readonly files: ReadonlyArray<{
                                                        readonly id: string;
                                                        readonly name: string | null;
                                                        readonly heightInPixels: number | null;
                                                        readonly widthInPixels: number | null;
                                                        readonly path: string | null;
                                                        readonly status: {
                                                            readonly kind: MediaAssetFileStatusKind | null;
                                                        } | null;
                                                    }> | null;
                                                    readonly state: {
                                                        readonly kind: MediaAssetStateKind | null;
                                                    } | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                                readonly kind: PreviewKind | null;
                                                readonly link: string | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                }> | null;
                                readonly entities?: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly description: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly count: number | null;
                                        readonly edges: ReadonlyArray<{
                                            readonly cursor: string | null;
                                            readonly preview: {
                                                readonly mediaAsset: {
                                                    readonly id: string;
                                                    readonly files: ReadonlyArray<{
                                                        readonly id: string;
                                                        readonly name: string | null;
                                                        readonly heightInPixels: number | null;
                                                        readonly widthInPixels: number | null;
                                                        readonly path: string | null;
                                                        readonly status: {
                                                            readonly kind: MediaAssetFileStatusKind | null;
                                                        } | null;
                                                    }> | null;
                                                    readonly state: {
                                                        readonly kind: MediaAssetStateKind | null;
                                                    } | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                                readonly kind: PreviewKind | null;
                                                readonly link: string | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                }> | null;
                                readonly peopleEntities?: ReadonlyArray<{
                                    readonly entity: {
                                        readonly __typename: string;
                                        readonly landingPageUrl: string | null;
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly websiteUrl: string | null;
                                        readonly industry: string | null;
                                        readonly fundingRound: string | null;
                                        readonly activities: ReadonlyArray<{
                                            readonly kind: EntityActivityKind | null;
                                            readonly label: string | null;
                                        }> | null;
                                        readonly people: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly role: string | null;
                                                readonly person: {
                                                    readonly __typename: string;
                                                    readonly id: string;
                                                    readonly fullName: string | null;
                                                    readonly landingPageUrl: string | null;
                                                    readonly previews: {
                                                        readonly edges: ReadonlyArray<{
                                                            readonly preview: {
                                                                readonly link: string | null;
                                                                readonly kind: PreviewKind | null;
                                                                readonly mediaAsset: {
                                                                    readonly files: ReadonlyArray<{
                                                                        readonly name: string | null;
                                                                        readonly path: string | null;
                                                                    }> | null;
                                                                    readonly topLevelMediaType: {
                                                                        readonly kind: TopLevelMediaKind | null;
                                                                    } | null;
                                                                } | null;
                                                            } | null;
                                                        }> | null;
                                                    } | null;
                                                };
                                            }> | null;
                                        } | null;
                                        readonly investmentsBy: ReadonlyArray<{
                                            readonly amount: string | null;
                                            readonly link: string | null;
                                            readonly deckUrl: string | null;
                                            readonly investmentDate: unknown | null;
                                        }> | null;
                                        readonly previews: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly cursor: string | null;
                                                readonly preview: {
                                                    readonly mediaAsset: {
                                                        readonly id: string;
                                                        readonly files: ReadonlyArray<{
                                                            readonly id: string;
                                                            readonly name: string | null;
                                                            readonly heightInPixels: number | null;
                                                            readonly widthInPixels: number | null;
                                                            readonly path: string | null;
                                                            readonly status: {
                                                                readonly kind: MediaAssetFileStatusKind | null;
                                                            } | null;
                                                        }> | null;
                                                        readonly state: {
                                                            readonly kind: MediaAssetStateKind | null;
                                                        } | null;
                                                        readonly topLevelMediaType: {
                                                            readonly kind: TopLevelMediaKind | null;
                                                        } | null;
                                                    } | null;
                                                    readonly kind: PreviewKind | null;
                                                    readonly link: string | null;
                                                } | null;
                                            }> | null;
                                        } | null;
                                    } | null;
                                    readonly person: {
                                        readonly __typename: string;
                                        readonly landingPageUrl: string | null;
                                        readonly id: string;
                                        readonly fullName: string | null;
                                        readonly responsibility: string | null;
                                        readonly description: string | null;
                                        readonly previews: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly cursor: string | null;
                                                readonly preview: {
                                                    readonly mediaAsset: {
                                                        readonly id: string;
                                                        readonly files: ReadonlyArray<{
                                                            readonly id: string;
                                                            readonly name: string | null;
                                                            readonly heightInPixels: number | null;
                                                            readonly widthInPixels: number | null;
                                                            readonly path: string | null;
                                                            readonly status: {
                                                                readonly kind: MediaAssetFileStatusKind | null;
                                                            } | null;
                                                        }> | null;
                                                        readonly state: {
                                                            readonly kind: MediaAssetStateKind | null;
                                                        } | null;
                                                        readonly topLevelMediaType: {
                                                            readonly kind: TopLevelMediaKind | null;
                                                        } | null;
                                                    } | null;
                                                    readonly kind: PreviewKind | null;
                                                    readonly link: string | null;
                                                } | null;
                                            }> | null;
                                        } | null;
                                    } | null;
                                }> | null;
                                readonly summary?: string | null;
                                readonly url?: string | null;
                                readonly title?: string | null;
                                readonly subTitle?: string | null;
                                readonly isPromoted?: boolean | null;
                                readonly trailer?: {
                                    readonly externalId: string | null;
                                    readonly description: string | null;
                                    readonly durationInSeconds: number | null;
                                    readonly link: string | null;
                                } | null;
                                readonly originalClip?: {
                                    readonly externalId: string | null;
                                    readonly durationInSeconds: number | null;
                                    readonly description: string | null;
                                    readonly link: string | null;
                                } | null;
                                readonly label?: string | null;
                                readonly revision?: string | null;
                                readonly landingPageUrl?: string | null;
                                readonly sourceList?: string | null;
                                readonly durationInSeconds?: number | null;
                                readonly link?: string | null;
                                readonly publisher?: string | null;
                                readonly actionDescription?: string | null;
                                readonly actionTitle?: string | null;
                                readonly permalink?: string | null;
                                readonly hasPublicPage?: boolean | null;
                                readonly fullName?: string | null;
                                readonly responsibility?: string | null;
                                readonly publishedDate?: unknown | null;
                                readonly timeToReadInSeconds?: number | null;
                                readonly cost?: string | null;
                                readonly timeRequiredInSeconds?: number | null;
                                readonly kind?: string | null;
                                readonly linkUrl?: string | null;
                                readonly previewUrl?: string | null;
                                readonly tags?: ReadonlyArray<string> | null;
                            } & ({
                                readonly __typename: "Event";
                                readonly id: string;
                                readonly name: string | null;
                                readonly description: string | null;
                                readonly end: unknown | null;
                                readonly start: unknown | null;
                                readonly status: EventStatusKind | null;
                                readonly externalId: string | null;
                                readonly created: unknown | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                                readonly people: ReadonlyArray<{
                                    readonly id: string;
                                    readonly fullName: string | null;
                                    readonly responsibility: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly count: number | null;
                                        readonly edges: ReadonlyArray<{
                                            readonly cursor: string | null;
                                            readonly preview: {
                                                readonly mediaAsset: {
                                                    readonly id: string;
                                                    readonly files: ReadonlyArray<{
                                                        readonly id: string;
                                                        readonly name: string | null;
                                                        readonly heightInPixels: number | null;
                                                        readonly widthInPixels: number | null;
                                                        readonly path: string | null;
                                                        readonly status: {
                                                            readonly kind: MediaAssetFileStatusKind | null;
                                                        } | null;
                                                    }> | null;
                                                    readonly state: {
                                                        readonly kind: MediaAssetStateKind | null;
                                                    } | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                                readonly kind: PreviewKind | null;
                                                readonly link: string | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                }> | null;
                                readonly entities: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly description: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly count: number | null;
                                        readonly edges: ReadonlyArray<{
                                            readonly cursor: string | null;
                                            readonly preview: {
                                                readonly mediaAsset: {
                                                    readonly id: string;
                                                    readonly files: ReadonlyArray<{
                                                        readonly id: string;
                                                        readonly name: string | null;
                                                        readonly heightInPixels: number | null;
                                                        readonly widthInPixels: number | null;
                                                        readonly path: string | null;
                                                        readonly status: {
                                                            readonly kind: MediaAssetFileStatusKind | null;
                                                        } | null;
                                                    }> | null;
                                                    readonly state: {
                                                        readonly kind: MediaAssetStateKind | null;
                                                    } | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                                readonly kind: PreviewKind | null;
                                                readonly link: string | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                }> | null;
                                readonly peopleEntities: ReadonlyArray<{
                                    readonly entity: {
                                        readonly __typename: string;
                                        readonly landingPageUrl: string | null;
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly websiteUrl: string | null;
                                        readonly industry: string | null;
                                        readonly fundingRound: string | null;
                                        readonly activities: ReadonlyArray<{
                                            readonly kind: EntityActivityKind | null;
                                            readonly label: string | null;
                                        }> | null;
                                        readonly people: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly role: string | null;
                                                readonly person: {
                                                    readonly __typename: string;
                                                    readonly id: string;
                                                    readonly fullName: string | null;
                                                    readonly landingPageUrl: string | null;
                                                    readonly previews: {
                                                        readonly edges: ReadonlyArray<{
                                                            readonly preview: {
                                                                readonly link: string | null;
                                                                readonly kind: PreviewKind | null;
                                                                readonly mediaAsset: {
                                                                    readonly files: ReadonlyArray<{
                                                                        readonly name: string | null;
                                                                        readonly path: string | null;
                                                                    }> | null;
                                                                    readonly topLevelMediaType: {
                                                                        readonly kind: TopLevelMediaKind | null;
                                                                    } | null;
                                                                } | null;
                                                            } | null;
                                                        }> | null;
                                                    } | null;
                                                };
                                            }> | null;
                                        } | null;
                                        readonly investmentsBy: ReadonlyArray<{
                                            readonly amount: string | null;
                                            readonly link: string | null;
                                            readonly deckUrl: string | null;
                                            readonly investmentDate: unknown | null;
                                        }> | null;
                                        readonly previews: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly cursor: string | null;
                                                readonly preview: {
                                                    readonly mediaAsset: {
                                                        readonly id: string;
                                                        readonly files: ReadonlyArray<{
                                                            readonly id: string;
                                                            readonly name: string | null;
                                                            readonly heightInPixels: number | null;
                                                            readonly widthInPixels: number | null;
                                                            readonly path: string | null;
                                                            readonly status: {
                                                                readonly kind: MediaAssetFileStatusKind | null;
                                                            } | null;
                                                        }> | null;
                                                        readonly state: {
                                                            readonly kind: MediaAssetStateKind | null;
                                                        } | null;
                                                        readonly topLevelMediaType: {
                                                            readonly kind: TopLevelMediaKind | null;
                                                        } | null;
                                                    } | null;
                                                    readonly kind: PreviewKind | null;
                                                    readonly link: string | null;
                                                } | null;
                                            }> | null;
                                        } | null;
                                    } | null;
                                    readonly person: {
                                        readonly __typename: string;
                                        readonly landingPageUrl: string | null;
                                        readonly id: string;
                                        readonly fullName: string | null;
                                        readonly responsibility: string | null;
                                        readonly description: string | null;
                                        readonly previews: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly cursor: string | null;
                                                readonly preview: {
                                                    readonly mediaAsset: {
                                                        readonly id: string;
                                                        readonly files: ReadonlyArray<{
                                                            readonly id: string;
                                                            readonly name: string | null;
                                                            readonly heightInPixels: number | null;
                                                            readonly widthInPixels: number | null;
                                                            readonly path: string | null;
                                                            readonly status: {
                                                                readonly kind: MediaAssetFileStatusKind | null;
                                                            } | null;
                                                        }> | null;
                                                        readonly state: {
                                                            readonly kind: MediaAssetStateKind | null;
                                                        } | null;
                                                        readonly topLevelMediaType: {
                                                            readonly kind: TopLevelMediaKind | null;
                                                        } | null;
                                                    } | null;
                                                    readonly kind: PreviewKind | null;
                                                    readonly link: string | null;
                                                } | null;
                                            }> | null;
                                        } | null;
                                    } | null;
                                }> | null;
                                readonly summary: string | null;
                                readonly url: string | null;
                            } | {
                                readonly __typename: "PitchVideoStory";
                                readonly title: string | null;
                                readonly subTitle: string | null;
                                readonly isPromoted: boolean | null;
                                readonly trailer: {
                                    readonly externalId: string | null;
                                    readonly description: string | null;
                                    readonly durationInSeconds: number | null;
                                    readonly link: string | null;
                                } | null;
                                readonly originalClip: {
                                    readonly externalId: string | null;
                                    readonly durationInSeconds: number | null;
                                    readonly description: string | null;
                                    readonly link: string | null;
                                } | null;
                                readonly label: string | null;
                                readonly revision: string | null;
                            } | {
                                readonly __typename: "OriginalContentStory";
                                readonly landingPageUrl: string | null;
                                readonly sourceList: string | null;
                                readonly durationInSeconds: number | null;
                                readonly link: string | null;
                            } | {
                                readonly __typename: "PodcastStory";
                                readonly publisher: string | null;
                            } | {
                                readonly __typename: "Poster";
                                readonly actionDescription: string | null;
                                readonly actionTitle: string | null;
                                readonly permalink: string | null;
                            } | {
                                readonly __typename: "Entity";
                                readonly hasPublicPage: boolean | null;
                            } | {
                                readonly __typename: "Person";
                                readonly fullName: string | null;
                                readonly responsibility: string | null;
                            } | {
                                readonly __typename: "ArticleStory";
                                readonly publishedDate: unknown | null;
                                readonly timeToReadInSeconds: number | null;
                            } | {
                                readonly __typename: "OnlineCourseStory";
                                readonly cost: string | null;
                                readonly timeRequiredInSeconds: number | null;
                            } | {
                                readonly __typename: "SearchHit";
                                readonly kind?: string | null;
                                readonly linkUrl?: string | null;
                                readonly previewUrl?: string | null;
                                readonly tags?: ReadonlyArray<string> | null;
                            } | {
                                /*This will never be '% other', but we need some
                                value in case none of the concrete values match.*/
                                readonly __typename: "%other";
                            })) | null;
                        } | null;
                    }> | null;
                } | null;
                readonly label?: string | null;
                readonly name?: string | null;
                readonly previews?: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly subTitle?: string | null;
                readonly title?: string | null;
                readonly revision?: string | null;
            } & ({
                readonly __typename: "FixedList";
                readonly description: string | null;
                readonly id: string;
                readonly items: {
                    readonly pageInfo: {
                        readonly hasNextPage: boolean | null;
                    } | null;
                    readonly edges: ReadonlyArray<{
                        readonly listItem: {
                            readonly item: ({
                                readonly __typename: string;
                                readonly id?: string;
                                readonly name?: string | null;
                                readonly description?: string | null;
                                readonly end?: unknown | null;
                                readonly start?: unknown | null;
                                readonly status?: EventStatusKind | null;
                                readonly externalId?: string | null;
                                readonly created?: unknown | null;
                                readonly previews?: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                                readonly people?: ReadonlyArray<{
                                    readonly id: string;
                                    readonly fullName: string | null;
                                    readonly responsibility: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly count: number | null;
                                        readonly edges: ReadonlyArray<{
                                            readonly cursor: string | null;
                                            readonly preview: {
                                                readonly mediaAsset: {
                                                    readonly id: string;
                                                    readonly files: ReadonlyArray<{
                                                        readonly id: string;
                                                        readonly name: string | null;
                                                        readonly heightInPixels: number | null;
                                                        readonly widthInPixels: number | null;
                                                        readonly path: string | null;
                                                        readonly status: {
                                                            readonly kind: MediaAssetFileStatusKind | null;
                                                        } | null;
                                                    }> | null;
                                                    readonly state: {
                                                        readonly kind: MediaAssetStateKind | null;
                                                    } | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                                readonly kind: PreviewKind | null;
                                                readonly link: string | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                }> | null;
                                readonly entities?: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly description: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly count: number | null;
                                        readonly edges: ReadonlyArray<{
                                            readonly cursor: string | null;
                                            readonly preview: {
                                                readonly mediaAsset: {
                                                    readonly id: string;
                                                    readonly files: ReadonlyArray<{
                                                        readonly id: string;
                                                        readonly name: string | null;
                                                        readonly heightInPixels: number | null;
                                                        readonly widthInPixels: number | null;
                                                        readonly path: string | null;
                                                        readonly status: {
                                                            readonly kind: MediaAssetFileStatusKind | null;
                                                        } | null;
                                                    }> | null;
                                                    readonly state: {
                                                        readonly kind: MediaAssetStateKind | null;
                                                    } | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                                readonly kind: PreviewKind | null;
                                                readonly link: string | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                }> | null;
                                readonly peopleEntities?: ReadonlyArray<{
                                    readonly entity: {
                                        readonly __typename: string;
                                        readonly landingPageUrl: string | null;
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly websiteUrl: string | null;
                                        readonly industry: string | null;
                                        readonly fundingRound: string | null;
                                        readonly activities: ReadonlyArray<{
                                            readonly kind: EntityActivityKind | null;
                                            readonly label: string | null;
                                        }> | null;
                                        readonly people: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly role: string | null;
                                                readonly person: {
                                                    readonly __typename: string;
                                                    readonly id: string;
                                                    readonly fullName: string | null;
                                                    readonly landingPageUrl: string | null;
                                                    readonly previews: {
                                                        readonly edges: ReadonlyArray<{
                                                            readonly preview: {
                                                                readonly link: string | null;
                                                                readonly kind: PreviewKind | null;
                                                                readonly mediaAsset: {
                                                                    readonly files: ReadonlyArray<{
                                                                        readonly name: string | null;
                                                                        readonly path: string | null;
                                                                    }> | null;
                                                                    readonly topLevelMediaType: {
                                                                        readonly kind: TopLevelMediaKind | null;
                                                                    } | null;
                                                                } | null;
                                                            } | null;
                                                        }> | null;
                                                    } | null;
                                                };
                                            }> | null;
                                        } | null;
                                        readonly investmentsBy: ReadonlyArray<{
                                            readonly amount: string | null;
                                            readonly link: string | null;
                                            readonly deckUrl: string | null;
                                            readonly investmentDate: unknown | null;
                                        }> | null;
                                        readonly previews: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly cursor: string | null;
                                                readonly preview: {
                                                    readonly mediaAsset: {
                                                        readonly id: string;
                                                        readonly files: ReadonlyArray<{
                                                            readonly id: string;
                                                            readonly name: string | null;
                                                            readonly heightInPixels: number | null;
                                                            readonly widthInPixels: number | null;
                                                            readonly path: string | null;
                                                            readonly status: {
                                                                readonly kind: MediaAssetFileStatusKind | null;
                                                            } | null;
                                                        }> | null;
                                                        readonly state: {
                                                            readonly kind: MediaAssetStateKind | null;
                                                        } | null;
                                                        readonly topLevelMediaType: {
                                                            readonly kind: TopLevelMediaKind | null;
                                                        } | null;
                                                    } | null;
                                                    readonly kind: PreviewKind | null;
                                                    readonly link: string | null;
                                                } | null;
                                            }> | null;
                                        } | null;
                                    } | null;
                                    readonly person: {
                                        readonly __typename: string;
                                        readonly landingPageUrl: string | null;
                                        readonly id: string;
                                        readonly fullName: string | null;
                                        readonly responsibility: string | null;
                                        readonly description: string | null;
                                        readonly previews: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly cursor: string | null;
                                                readonly preview: {
                                                    readonly mediaAsset: {
                                                        readonly id: string;
                                                        readonly files: ReadonlyArray<{
                                                            readonly id: string;
                                                            readonly name: string | null;
                                                            readonly heightInPixels: number | null;
                                                            readonly widthInPixels: number | null;
                                                            readonly path: string | null;
                                                            readonly status: {
                                                                readonly kind: MediaAssetFileStatusKind | null;
                                                            } | null;
                                                        }> | null;
                                                        readonly state: {
                                                            readonly kind: MediaAssetStateKind | null;
                                                        } | null;
                                                        readonly topLevelMediaType: {
                                                            readonly kind: TopLevelMediaKind | null;
                                                        } | null;
                                                    } | null;
                                                    readonly kind: PreviewKind | null;
                                                    readonly link: string | null;
                                                } | null;
                                            }> | null;
                                        } | null;
                                    } | null;
                                }> | null;
                                readonly summary?: string | null;
                                readonly url?: string | null;
                                readonly title?: string | null;
                                readonly subTitle?: string | null;
                                readonly isPromoted?: boolean | null;
                                readonly trailer?: {
                                    readonly externalId: string | null;
                                    readonly description: string | null;
                                    readonly durationInSeconds: number | null;
                                    readonly link: string | null;
                                } | null;
                                readonly originalClip?: {
                                    readonly externalId: string | null;
                                    readonly durationInSeconds: number | null;
                                    readonly description: string | null;
                                    readonly link: string | null;
                                } | null;
                                readonly label?: string | null;
                                readonly revision?: string | null;
                                readonly landingPageUrl?: string | null;
                                readonly sourceList?: string | null;
                                readonly durationInSeconds?: number | null;
                                readonly link?: string | null;
                                readonly publisher?: string | null;
                                readonly actionDescription?: string | null;
                                readonly actionTitle?: string | null;
                                readonly permalink?: string | null;
                                readonly hasPublicPage?: boolean | null;
                                readonly fullName?: string | null;
                                readonly responsibility?: string | null;
                                readonly publishedDate?: unknown | null;
                                readonly timeToReadInSeconds?: number | null;
                                readonly cost?: string | null;
                                readonly timeRequiredInSeconds?: number | null;
                                readonly kind?: string | null;
                                readonly linkUrl?: string | null;
                                readonly previewUrl?: string | null;
                                readonly tags?: ReadonlyArray<string> | null;
                            } & ({
                                readonly __typename: "Event";
                                readonly id: string;
                                readonly name: string | null;
                                readonly description: string | null;
                                readonly end: unknown | null;
                                readonly start: unknown | null;
                                readonly status: EventStatusKind | null;
                                readonly externalId: string | null;
                                readonly created: unknown | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                                readonly people: ReadonlyArray<{
                                    readonly id: string;
                                    readonly fullName: string | null;
                                    readonly responsibility: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly count: number | null;
                                        readonly edges: ReadonlyArray<{
                                            readonly cursor: string | null;
                                            readonly preview: {
                                                readonly mediaAsset: {
                                                    readonly id: string;
                                                    readonly files: ReadonlyArray<{
                                                        readonly id: string;
                                                        readonly name: string | null;
                                                        readonly heightInPixels: number | null;
                                                        readonly widthInPixels: number | null;
                                                        readonly path: string | null;
                                                        readonly status: {
                                                            readonly kind: MediaAssetFileStatusKind | null;
                                                        } | null;
                                                    }> | null;
                                                    readonly state: {
                                                        readonly kind: MediaAssetStateKind | null;
                                                    } | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                                readonly kind: PreviewKind | null;
                                                readonly link: string | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                }> | null;
                                readonly entities: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly description: string | null;
                                    readonly landingPageUrl: string | null;
                                    readonly previews: {
                                        readonly count: number | null;
                                        readonly edges: ReadonlyArray<{
                                            readonly cursor: string | null;
                                            readonly preview: {
                                                readonly mediaAsset: {
                                                    readonly id: string;
                                                    readonly files: ReadonlyArray<{
                                                        readonly id: string;
                                                        readonly name: string | null;
                                                        readonly heightInPixels: number | null;
                                                        readonly widthInPixels: number | null;
                                                        readonly path: string | null;
                                                        readonly status: {
                                                            readonly kind: MediaAssetFileStatusKind | null;
                                                        } | null;
                                                    }> | null;
                                                    readonly state: {
                                                        readonly kind: MediaAssetStateKind | null;
                                                    } | null;
                                                    readonly topLevelMediaType: {
                                                        readonly kind: TopLevelMediaKind | null;
                                                    } | null;
                                                } | null;
                                                readonly kind: PreviewKind | null;
                                                readonly link: string | null;
                                            } | null;
                                        }> | null;
                                    } | null;
                                }> | null;
                                readonly peopleEntities: ReadonlyArray<{
                                    readonly entity: {
                                        readonly __typename: string;
                                        readonly landingPageUrl: string | null;
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly websiteUrl: string | null;
                                        readonly industry: string | null;
                                        readonly fundingRound: string | null;
                                        readonly activities: ReadonlyArray<{
                                            readonly kind: EntityActivityKind | null;
                                            readonly label: string | null;
                                        }> | null;
                                        readonly people: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly role: string | null;
                                                readonly person: {
                                                    readonly __typename: string;
                                                    readonly id: string;
                                                    readonly fullName: string | null;
                                                    readonly landingPageUrl: string | null;
                                                    readonly previews: {
                                                        readonly edges: ReadonlyArray<{
                                                            readonly preview: {
                                                                readonly link: string | null;
                                                                readonly kind: PreviewKind | null;
                                                                readonly mediaAsset: {
                                                                    readonly files: ReadonlyArray<{
                                                                        readonly name: string | null;
                                                                        readonly path: string | null;
                                                                    }> | null;
                                                                    readonly topLevelMediaType: {
                                                                        readonly kind: TopLevelMediaKind | null;
                                                                    } | null;
                                                                } | null;
                                                            } | null;
                                                        }> | null;
                                                    } | null;
                                                };
                                            }> | null;
                                        } | null;
                                        readonly investmentsBy: ReadonlyArray<{
                                            readonly amount: string | null;
                                            readonly link: string | null;
                                            readonly deckUrl: string | null;
                                            readonly investmentDate: unknown | null;
                                        }> | null;
                                        readonly previews: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly cursor: string | null;
                                                readonly preview: {
                                                    readonly mediaAsset: {
                                                        readonly id: string;
                                                        readonly files: ReadonlyArray<{
                                                            readonly id: string;
                                                            readonly name: string | null;
                                                            readonly heightInPixels: number | null;
                                                            readonly widthInPixels: number | null;
                                                            readonly path: string | null;
                                                            readonly status: {
                                                                readonly kind: MediaAssetFileStatusKind | null;
                                                            } | null;
                                                        }> | null;
                                                        readonly state: {
                                                            readonly kind: MediaAssetStateKind | null;
                                                        } | null;
                                                        readonly topLevelMediaType: {
                                                            readonly kind: TopLevelMediaKind | null;
                                                        } | null;
                                                    } | null;
                                                    readonly kind: PreviewKind | null;
                                                    readonly link: string | null;
                                                } | null;
                                            }> | null;
                                        } | null;
                                    } | null;
                                    readonly person: {
                                        readonly __typename: string;
                                        readonly landingPageUrl: string | null;
                                        readonly id: string;
                                        readonly fullName: string | null;
                                        readonly responsibility: string | null;
                                        readonly description: string | null;
                                        readonly previews: {
                                            readonly count: number | null;
                                            readonly edges: ReadonlyArray<{
                                                readonly cursor: string | null;
                                                readonly preview: {
                                                    readonly mediaAsset: {
                                                        readonly id: string;
                                                        readonly files: ReadonlyArray<{
                                                            readonly id: string;
                                                            readonly name: string | null;
                                                            readonly heightInPixels: number | null;
                                                            readonly widthInPixels: number | null;
                                                            readonly path: string | null;
                                                            readonly status: {
                                                                readonly kind: MediaAssetFileStatusKind | null;
                                                            } | null;
                                                        }> | null;
                                                        readonly state: {
                                                            readonly kind: MediaAssetStateKind | null;
                                                        } | null;
                                                        readonly topLevelMediaType: {
                                                            readonly kind: TopLevelMediaKind | null;
                                                        } | null;
                                                    } | null;
                                                    readonly kind: PreviewKind | null;
                                                    readonly link: string | null;
                                                } | null;
                                            }> | null;
                                        } | null;
                                    } | null;
                                }> | null;
                                readonly summary: string | null;
                                readonly url: string | null;
                            } | {
                                readonly __typename: "PitchVideoStory";
                                readonly title: string | null;
                                readonly subTitle: string | null;
                                readonly isPromoted: boolean | null;
                                readonly trailer: {
                                    readonly externalId: string | null;
                                    readonly description: string | null;
                                    readonly durationInSeconds: number | null;
                                    readonly link: string | null;
                                } | null;
                                readonly originalClip: {
                                    readonly externalId: string | null;
                                    readonly durationInSeconds: number | null;
                                    readonly description: string | null;
                                    readonly link: string | null;
                                } | null;
                                readonly label: string | null;
                                readonly revision: string | null;
                            } | {
                                readonly __typename: "OriginalContentStory";
                                readonly landingPageUrl: string | null;
                                readonly sourceList: string | null;
                                readonly durationInSeconds: number | null;
                                readonly link: string | null;
                            } | {
                                readonly __typename: "PodcastStory";
                                readonly publisher: string | null;
                            } | {
                                readonly __typename: "Poster";
                                readonly actionDescription: string | null;
                                readonly actionTitle: string | null;
                                readonly permalink: string | null;
                            } | {
                                readonly __typename: "Entity";
                                readonly hasPublicPage: boolean | null;
                            } | {
                                readonly __typename: "Person";
                                readonly fullName: string | null;
                                readonly responsibility: string | null;
                            } | {
                                readonly __typename: "ArticleStory";
                                readonly publishedDate: unknown | null;
                                readonly timeToReadInSeconds: number | null;
                            } | {
                                readonly __typename: "OnlineCourseStory";
                                readonly cost: string | null;
                                readonly timeRequiredInSeconds: number | null;
                            } | {
                                readonly __typename: "SearchHit";
                                readonly kind?: string | null;
                                readonly linkUrl?: string | null;
                                readonly previewUrl?: string | null;
                                readonly tags?: ReadonlyArray<string> | null;
                            } | {
                                /*This will never be '% other', but we need some
                                value in case none of the concrete values match.*/
                                readonly __typename: "%other";
                            })) | null;
                        } | null;
                    }> | null;
                } | null;
                readonly label: string | null;
                readonly name: string | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly subTitle: string | null;
                readonly title: string | null;
                readonly revision: string | null;
            } | {
                /*This will never be '% other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            })> | null;
            readonly previews: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly preview: {
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly heightInPixels: number | null;
                                readonly widthInPixels: number | null;
                                readonly path: string | null;
                                readonly status: {
                                    readonly kind: MediaAssetFileStatusKind | null;
                                } | null;
                            }> | null;
                            readonly state: {
                                readonly kind: MediaAssetStateKind | null;
                            } | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                            } | null;
                        } | null;
                        readonly kind: PreviewKind | null;
                        readonly link: string | null;
                    } | null;
                }> | null;
            } | null;
            readonly name: string | null;
            readonly subTitle: string | null;
            readonly title: string | null;
            readonly revision: string | null;
        } | null;
    } | null;
};
export type listCollectionQuery = {
    readonly response: listCollectionQueryResponse;
    readonly variables: listCollectionQueryVariables;
};



/*
query listCollectionQuery(
  $listCollectionId: ID!
  $count: Int
) {
  listCollection(id: $listCollectionId) {
    errors {
      created
      id
      location
      type
    }
    hasErrors
    listCollection {
      description
      id
      label
      badges {
        imageLink
        link
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
        id
      }
      lists {
        __typename
        ... on FixedList {
          description
          id
          items(first: $count) {
            pageInfo {
              hasNextPage
            }
            edges {
              listItem {
                item {
                  __typename
                  ... on Event {
                    __typename
                    id
                    name
                    description
                    end
                    start
                    status
                    externalId
                    created
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                    people {
                      id
                      fullName
                      responsibility
                      landingPageUrl
                      previews {
                        count
                        edges {
                          cursor
                          preview {
                            mediaAsset {
                              id
                              files {
                                id
                                name
                                heightInPixels
                                widthInPixels
                                path
                                status {
                                  kind
                                  id
                                }
                              }
                              state {
                                kind
                                id
                              }
                              topLevelMediaType {
                                kind
                                id
                              }
                            }
                            kind
                            link
                          }
                        }
                      }
                    }
                    entities {
                      id
                      name
                      description
                      landingPageUrl
                      previews {
                        count
                        edges {
                          cursor
                          preview {
                            mediaAsset {
                              id
                              files {
                                id
                                name
                                heightInPixels
                                widthInPixels
                                path
                                status {
                                  kind
                                  id
                                }
                              }
                              state {
                                kind
                                id
                              }
                              topLevelMediaType {
                                kind
                                id
                              }
                            }
                            kind
                            link
                          }
                        }
                      }
                    }
                    peopleEntities {
                      entity {
                        __typename
                        landingPageUrl
                        id
                        name
                        websiteUrl
                        industry
                        fundingRound
                        activities {
                          kind
                          label
                          id
                        }
                        people {
                          count
                          edges {
                            role
                            person {
                              __typename
                              id
                              fullName
                              landingPageUrl
                              previews {
                                edges {
                                  preview {
                                    link
                                    kind
                                    mediaAsset {
                                      files {
                                        name
                                        path
                                        id
                                      }
                                      topLevelMediaType {
                                        kind
                                        id
                                      }
                                      id
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                        investmentsBy {
                          amount
                          link
                          deckUrl
                          investmentDate
                          id
                        }
                        previews {
                          count
                          edges {
                            cursor
                            preview {
                              mediaAsset {
                                id
                                files {
                                  id
                                  name
                                  heightInPixels
                                  widthInPixels
                                  path
                                  status {
                                    kind
                                    id
                                  }
                                }
                                state {
                                  kind
                                  id
                                }
                                topLevelMediaType {
                                  kind
                                  id
                                }
                              }
                              kind
                              link
                            }
                          }
                        }
                      }
                      person {
                        __typename
                        landingPageUrl
                        id
                        fullName
                        responsibility
                        description
                        previews {
                          count
                          edges {
                            cursor
                            preview {
                              mediaAsset {
                                id
                                files {
                                  id
                                  name
                                  heightInPixels
                                  widthInPixels
                                  path
                                  status {
                                    kind
                                    id
                                  }
                                }
                                state {
                                  kind
                                  id
                                }
                                topLevelMediaType {
                                  kind
                                  id
                                }
                              }
                              kind
                              link
                            }
                          }
                        }
                      }
                    }
                    summary
                    url
                  }
                  ... on PitchVideoStory {
                    __typename
                    id
                    title
                    description
                    subTitle
                    isPromoted
                    trailer {
                      externalId
                      description
                      durationInSeconds
                      link
                    }
                    originalClip {
                      externalId
                      durationInSeconds
                      description
                      link
                    }
                    label
                    peopleEntities {
                      entity {
                        __typename
                        landingPageUrl
                        id
                        name
                        websiteUrl
                        industry
                        fundingRound
                        activities {
                          kind
                          label
                          id
                        }
                        people {
                          count
                          edges {
                            role
                            person {
                              __typename
                              id
                              fullName
                              landingPageUrl
                              previews {
                                edges {
                                  preview {
                                    link
                                    kind
                                    mediaAsset {
                                      files {
                                        name
                                        path
                                        id
                                      }
                                      topLevelMediaType {
                                        kind
                                        id
                                      }
                                      id
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                        investmentsBy {
                          amount
                          link
                          deckUrl
                          investmentDate
                          id
                        }
                        previews {
                          count
                          edges {
                            cursor
                            preview {
                              mediaAsset {
                                id
                                files {
                                  id
                                  name
                                  heightInPixels
                                  widthInPixels
                                  path
                                  status {
                                    kind
                                    id
                                  }
                                }
                                state {
                                  kind
                                  id
                                }
                                topLevelMediaType {
                                  kind
                                  id
                                }
                              }
                              kind
                              link
                            }
                          }
                        }
                      }
                      person {
                        __typename
                        landingPageUrl
                        id
                        fullName
                        responsibility
                        description
                        previews {
                          count
                          edges {
                            cursor
                            preview {
                              mediaAsset {
                                id
                                files {
                                  id
                                  name
                                  heightInPixels
                                  widthInPixels
                                  path
                                  status {
                                    kind
                                    id
                                  }
                                }
                                state {
                                  kind
                                  id
                                }
                                topLevelMediaType {
                                  kind
                                  id
                                }
                              }
                              kind
                              link
                            }
                          }
                        }
                      }
                    }
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                    revision
                  }
                  ... on OriginalContentStory {
                    __typename
                    id
                    revision
                    landingPageUrl
                    sourceList
                    durationInSeconds
                    description
                    externalId
                    subTitle
                    title
                    label
                    link
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                  }
                  ... on PodcastStory {
                    __typename
                    description
                    durationInSeconds
                    id
                    title
                    subTitle
                    link
                    publisher
                    landingPageUrl
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                    revision
                  }
                  ... on Poster {
                    __typename
                    actionDescription
                    actionTitle
                    description
                    permalink
                    id
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                    subTitle
                    title
                    revision
                  }
                  ... on Entity {
                    __typename
                    description
                    hasPublicPage
                    id
                    name
                    landingPageUrl
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                  }
                  ... on Person {
                    __typename
                    hasPublicPage
                    id
                    fullName
                    landingPageUrl
                    description
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                    responsibility
                  }
                  ... on ArticleStory {
                    __typename
                    description
                    id
                    link
                    subTitle
                    title
                    publisher
                    publishedDate
                    timeToReadInSeconds
                    revision
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                  }
                  ... on BookStory {
                    __typename
                    description
                    id
                    link
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                    subTitle
                    title
                  }
                  ... on NewsletterStory {
                    __typename
                    description
                    link
                    id
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                    subTitle
                    title
                    publisher
                    publishedDate
                    timeToReadInSeconds
                  }
                  ... on OnlineCourseStory {
                    __typename
                    description
                    id
                    link
                    cost
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                    subTitle
                    title
                    publishedDate
                    timeRequiredInSeconds
                    publisher
                    revision
                  }
                  ... on Node {
                    id
                  }
                  ... on SearchHit {
                    id
                  }
                  ... on Tag {
                    id
                  }
                }
                id
              }
            }
          }
          label
          name
          previews {
            count
            edges {
              cursor
              preview {
                mediaAsset {
                  id
                  files {
                    id
                    name
                    heightInPixels
                    widthInPixels
                    path
                    status {
                      kind
                      id
                    }
                  }
                  state {
                    kind
                    id
                  }
                  topLevelMediaType {
                    kind
                    id
                  }
                }
                kind
                link
              }
            }
          }
          subTitle
          title
          revision
        }
        ... on DynamicList {
          description
          id
          label
          name
          items(first: $count) {
            edges {
              listItem {
                item {
                  __typename
                  ... on SearchHit {
                    __typename
                    id
                    kind
                    label
                    linkUrl
                    name
                    previewUrl
                    publisher
                    landingPageUrl
                    responsibility
                    subTitle
                    title
                    tags
                  }
                  ... on Node {
                    id
                  }
                  ... on Tag {
                    id
                  }
                }
                id
              }
            }
          }
          previews {
            count
            edges {
              cursor
              preview {
                mediaAsset {
                  id
                  files {
                    id
                    name
                    heightInPixels
                    widthInPixels
                    path
                    status {
                      kind
                      id
                    }
                  }
                  state {
                    kind
                    id
                  }
                  topLevelMediaType {
                    kind
                    id
                  }
                }
                kind
                link
              }
            }
          }
          subTitle
          title
          revision
        }
        ... on Node {
          id
        }
      }
      previews {
        count
        edges {
          cursor
          preview {
            mediaAsset {
              id
              files {
                id
                name
                heightInPixels
                widthInPixels
                path
                status {
                  kind
                  id
                }
              }
              state {
                kind
                id
              }
              topLevelMediaType {
                kind
                id
              }
            }
            kind
            link
          }
        }
      }
      name
      subTitle
      title
      revision
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "listCollectionId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "listCollectionId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageLink",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "heightInPixels",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "widthInPixels",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v17/*: any*/)
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v3/*: any*/),
                    (v12/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v15/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v17/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v17/*: any*/)
                },
                (v18/*: any*/)
              ]
            },
            (v16/*: any*/),
            (v9/*: any*/)
          ]
        }
      ]
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v21 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "externalId",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "websiteUrl",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "industry",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fundingRound",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "role",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "deckUrl",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "investmentDate",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "peopleEntities",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityPerson",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "entity",
      "storageKey": null,
      "args": null,
      "concreteType": "Entity",
      "plural": false,
      "selections": [
        (v20/*: any*/),
        (v29/*: any*/),
        (v3/*: any*/),
        (v12/*: any*/),
        (v30/*: any*/),
        (v31/*: any*/),
        (v32/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "activities",
          "storageKey": null,
          "args": null,
          "concreteType": "EntityActivity",
          "plural": true,
          "selections": [
            (v16/*: any*/),
            (v7/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "people",
          "storageKey": null,
          "args": null,
          "concreteType": "EntityOwnersConnection",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EntityOwner",
              "plural": true,
              "selections": [
                (v33/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "person",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Person",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    (v3/*: any*/),
                    (v27/*: any*/),
                    (v29/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "previews",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PreviewsConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "PreviewEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "preview",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Preview",
                              "plural": false,
                              "selections": [
                                (v9/*: any*/),
                                (v16/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "mediaAsset",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "MediaAsset",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "files",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "MediaAssetFile",
                                      "plural": true,
                                      "selections": [
                                        (v12/*: any*/),
                                        (v15/*: any*/)
                                      ]
                                    },
                                    (v18/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "investmentsBy",
          "storageKey": null,
          "args": null,
          "concreteType": "Investment",
          "plural": true,
          "selections": [
            (v34/*: any*/),
            (v9/*: any*/),
            (v35/*: any*/),
            (v36/*: any*/)
          ]
        },
        (v19/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "person",
      "storageKey": null,
      "args": null,
      "concreteType": "Person",
      "plural": false,
      "selections": [
        (v20/*: any*/),
        (v29/*: any*/),
        (v3/*: any*/),
        (v27/*: any*/),
        (v28/*: any*/),
        (v6/*: any*/),
        (v19/*: any*/)
      ]
    }
  ]
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "summary",
  "args": null,
  "storageKey": null
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isPromoted",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "durationInSeconds",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "trailer",
  "storageKey": null,
  "args": null,
  "concreteType": "PitchVideoDetails",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v6/*: any*/),
    (v43/*: any*/),
    (v9/*: any*/)
  ]
},
v45 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "originalClip",
  "storageKey": null,
  "args": null,
  "concreteType": "PitchVideoDetails",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v43/*: any*/),
    (v6/*: any*/),
    (v9/*: any*/)
  ]
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sourceList",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publisher",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionDescription",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionTitle",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "permalink",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPublicPage",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishedDate",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeToReadInSeconds",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cost",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeRequiredInSeconds",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkUrl",
  "args": null,
  "storageKey": null
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "previewUrl",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tags",
  "args": null,
  "storageKey": null
},
v60 = [
  (v16/*: any*/),
  (v3/*: any*/)
],
v61 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v60/*: any*/)
},
v62 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v3/*: any*/),
                    (v12/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v15/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v60/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v60/*: any*/)
                },
                (v61/*: any*/)
              ]
            },
            (v16/*: any*/),
            (v9/*: any*/)
          ]
        }
      ]
    }
  ]
},
v63 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "peopleEntities",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityPerson",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "entity",
      "storageKey": null,
      "args": null,
      "concreteType": "Entity",
      "plural": false,
      "selections": [
        (v20/*: any*/),
        (v29/*: any*/),
        (v3/*: any*/),
        (v12/*: any*/),
        (v30/*: any*/),
        (v31/*: any*/),
        (v32/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "activities",
          "storageKey": null,
          "args": null,
          "concreteType": "EntityActivity",
          "plural": true,
          "selections": [
            (v16/*: any*/),
            (v7/*: any*/),
            (v3/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "people",
          "storageKey": null,
          "args": null,
          "concreteType": "EntityOwnersConnection",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EntityOwner",
              "plural": true,
              "selections": [
                (v33/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "person",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Person",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    (v3/*: any*/),
                    (v27/*: any*/),
                    (v29/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "previews",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PreviewsConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "PreviewEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "preview",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Preview",
                              "plural": false,
                              "selections": [
                                (v9/*: any*/),
                                (v16/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "mediaAsset",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "MediaAsset",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "files",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "MediaAssetFile",
                                      "plural": true,
                                      "selections": [
                                        (v12/*: any*/),
                                        (v15/*: any*/),
                                        (v3/*: any*/)
                                      ]
                                    },
                                    (v61/*: any*/),
                                    (v3/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "investmentsBy",
          "storageKey": null,
          "args": null,
          "concreteType": "Investment",
          "plural": true,
          "selections": [
            (v34/*: any*/),
            (v9/*: any*/),
            (v35/*: any*/),
            (v36/*: any*/),
            (v3/*: any*/)
          ]
        },
        (v62/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "person",
      "storageKey": null,
      "args": null,
      "concreteType": "Person",
      "plural": false,
      "selections": [
        (v20/*: any*/),
        (v29/*: any*/),
        (v3/*: any*/),
        (v27/*: any*/),
        (v28/*: any*/),
        (v6/*: any*/),
        (v62/*: any*/)
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "listCollectionQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "listCollection",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListCollectionPayload",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "listCollection",
            "storageKey": null,
            "args": null,
            "concreteType": "ListCollection",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v3/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "badges",
                "storageKey": null,
                "args": null,
                "concreteType": "Badge",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v19/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lists",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "type": "FixedList",
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": (v21/*: any*/),
                        "concreteType": "ListItemsConnection",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItemEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "listItem",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ListItem",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "item",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Event",
                                        "selections": [
                                          (v3/*: any*/),
                                          (v12/*: any*/),
                                          (v6/*: any*/),
                                          (v23/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/),
                                          (v2/*: any*/),
                                          (v19/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "people",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Person",
                                            "plural": true,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v29/*: any*/),
                                              (v19/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entities",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Entity",
                                            "plural": true,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v12/*: any*/),
                                              (v6/*: any*/),
                                              (v29/*: any*/),
                                              (v19/*: any*/)
                                            ]
                                          },
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          (v39/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "PitchVideoStory",
                                        "selections": [
                                          (v3/*: any*/),
                                          (v40/*: any*/),
                                          (v6/*: any*/),
                                          (v41/*: any*/),
                                          (v42/*: any*/),
                                          (v44/*: any*/),
                                          (v45/*: any*/),
                                          (v7/*: any*/),
                                          (v37/*: any*/),
                                          (v19/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "OriginalContentStory",
                                        "selections": [
                                          (v3/*: any*/),
                                          (v46/*: any*/),
                                          (v29/*: any*/),
                                          (v47/*: any*/),
                                          (v43/*: any*/),
                                          (v6/*: any*/),
                                          (v26/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v7/*: any*/),
                                          (v9/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "PodcastStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v43/*: any*/),
                                          (v3/*: any*/),
                                          (v40/*: any*/),
                                          (v41/*: any*/),
                                          (v9/*: any*/),
                                          (v48/*: any*/),
                                          (v29/*: any*/),
                                          (v19/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Poster",
                                        "selections": [
                                          (v49/*: any*/),
                                          (v50/*: any*/),
                                          (v6/*: any*/),
                                          (v51/*: any*/),
                                          (v3/*: any*/),
                                          (v19/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Entity",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v52/*: any*/),
                                          (v3/*: any*/),
                                          (v12/*: any*/),
                                          (v29/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Person",
                                        "selections": [
                                          (v52/*: any*/),
                                          (v3/*: any*/),
                                          (v27/*: any*/),
                                          (v29/*: any*/),
                                          (v6/*: any*/),
                                          (v19/*: any*/),
                                          (v28/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "ArticleStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v3/*: any*/),
                                          (v9/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v48/*: any*/),
                                          (v53/*: any*/),
                                          (v54/*: any*/),
                                          (v46/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "BookStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v3/*: any*/),
                                          (v9/*: any*/),
                                          (v19/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "NewsletterStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v9/*: any*/),
                                          (v3/*: any*/),
                                          (v19/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v48/*: any*/),
                                          (v53/*: any*/),
                                          (v54/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "OnlineCourseStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v3/*: any*/),
                                          (v9/*: any*/),
                                          (v55/*: any*/),
                                          (v19/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v53/*: any*/),
                                          (v56/*: any*/),
                                          (v48/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v7/*: any*/),
                      (v12/*: any*/),
                      (v19/*: any*/),
                      (v41/*: any*/),
                      (v40/*: any*/),
                      (v46/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "DynamicList",
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": (v21/*: any*/),
                        "concreteType": "ListItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItemEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "listItem",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ListItem",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "item",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "type": "SearchHit",
                                        "selections": [
                                          (v3/*: any*/),
                                          (v16/*: any*/),
                                          (v7/*: any*/),
                                          (v57/*: any*/),
                                          (v12/*: any*/),
                                          (v58/*: any*/),
                                          (v48/*: any*/),
                                          (v29/*: any*/),
                                          (v28/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v59/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v19/*: any*/),
                      (v41/*: any*/),
                      (v40/*: any*/),
                      (v46/*: any*/)
                    ]
                  }
                ]
              },
              (v19/*: any*/),
              (v12/*: any*/),
              (v41/*: any*/),
              (v40/*: any*/),
              (v46/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "listCollectionQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "listCollection",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListCollectionPayload",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "listCollection",
            "storageKey": null,
            "args": null,
            "concreteType": "ListCollection",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v3/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "badges",
                "storageKey": null,
                "args": null,
                "concreteType": "Badge",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v62/*: any*/),
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lists",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "type": "FixedList",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": (v21/*: any*/),
                        "concreteType": "ListItemsConnection",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItemEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "listItem",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ListItem",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "item",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Event",
                                        "selections": [
                                          (v12/*: any*/),
                                          (v6/*: any*/),
                                          (v23/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/),
                                          (v2/*: any*/),
                                          (v62/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "people",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Person",
                                            "plural": true,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v29/*: any*/),
                                              (v62/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entities",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Entity",
                                            "plural": true,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v12/*: any*/),
                                              (v6/*: any*/),
                                              (v29/*: any*/),
                                              (v62/*: any*/)
                                            ]
                                          },
                                          (v63/*: any*/),
                                          (v38/*: any*/),
                                          (v39/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "PitchVideoStory",
                                        "selections": [
                                          (v40/*: any*/),
                                          (v6/*: any*/),
                                          (v41/*: any*/),
                                          (v42/*: any*/),
                                          (v44/*: any*/),
                                          (v45/*: any*/),
                                          (v7/*: any*/),
                                          (v63/*: any*/),
                                          (v62/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "OriginalContentStory",
                                        "selections": [
                                          (v46/*: any*/),
                                          (v29/*: any*/),
                                          (v47/*: any*/),
                                          (v43/*: any*/),
                                          (v6/*: any*/),
                                          (v26/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v7/*: any*/),
                                          (v9/*: any*/),
                                          (v62/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "PodcastStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v43/*: any*/),
                                          (v40/*: any*/),
                                          (v41/*: any*/),
                                          (v9/*: any*/),
                                          (v48/*: any*/),
                                          (v29/*: any*/),
                                          (v62/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Poster",
                                        "selections": [
                                          (v49/*: any*/),
                                          (v50/*: any*/),
                                          (v6/*: any*/),
                                          (v51/*: any*/),
                                          (v62/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Entity",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v52/*: any*/),
                                          (v12/*: any*/),
                                          (v29/*: any*/),
                                          (v62/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Person",
                                        "selections": [
                                          (v52/*: any*/),
                                          (v27/*: any*/),
                                          (v29/*: any*/),
                                          (v6/*: any*/),
                                          (v62/*: any*/),
                                          (v28/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "ArticleStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v9/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v48/*: any*/),
                                          (v53/*: any*/),
                                          (v54/*: any*/),
                                          (v46/*: any*/),
                                          (v62/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "BookStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v9/*: any*/),
                                          (v62/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "NewsletterStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v9/*: any*/),
                                          (v62/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v48/*: any*/),
                                          (v53/*: any*/),
                                          (v54/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "OnlineCourseStory",
                                        "selections": [
                                          (v6/*: any*/),
                                          (v9/*: any*/),
                                          (v55/*: any*/),
                                          (v62/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v53/*: any*/),
                                          (v56/*: any*/),
                                          (v48/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v3/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v7/*: any*/),
                      (v12/*: any*/),
                      (v62/*: any*/),
                      (v41/*: any*/),
                      (v40/*: any*/),
                      (v46/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "DynamicList",
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": (v21/*: any*/),
                        "concreteType": "ListItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItemEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "listItem",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ListItem",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "item",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "type": "SearchHit",
                                        "selections": [
                                          (v16/*: any*/),
                                          (v7/*: any*/),
                                          (v57/*: any*/),
                                          (v12/*: any*/),
                                          (v58/*: any*/),
                                          (v48/*: any*/),
                                          (v29/*: any*/),
                                          (v28/*: any*/),
                                          (v41/*: any*/),
                                          (v40/*: any*/),
                                          (v59/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v3/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v62/*: any*/),
                      (v41/*: any*/),
                      (v40/*: any*/),
                      (v46/*: any*/)
                    ]
                  }
                ]
              },
              (v62/*: any*/),
              (v12/*: any*/),
              (v41/*: any*/),
              (v40/*: any*/),
              (v46/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "listCollectionQuery",
    "id": null,
    "text": "query listCollectionQuery(\n  $listCollectionId: ID!\n  $count: Int\n) {\n  listCollection(id: $listCollectionId) {\n    errors {\n      created\n      id\n      location\n      type\n    }\n    hasErrors\n    listCollection {\n      description\n      id\n      label\n      badges {\n        imageLink\n        link\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n        id\n      }\n      lists {\n        __typename\n        ... on FixedList {\n          description\n          id\n          items(first: $count) {\n            pageInfo {\n              hasNextPage\n            }\n            edges {\n              listItem {\n                item {\n                  __typename\n                  ... on Event {\n                    __typename\n                    id\n                    name\n                    description\n                    end\n                    start\n                    status\n                    externalId\n                    created\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                    people {\n                      id\n                      fullName\n                      responsibility\n                      landingPageUrl\n                      previews {\n                        count\n                        edges {\n                          cursor\n                          preview {\n                            mediaAsset {\n                              id\n                              files {\n                                id\n                                name\n                                heightInPixels\n                                widthInPixels\n                                path\n                                status {\n                                  kind\n                                  id\n                                }\n                              }\n                              state {\n                                kind\n                                id\n                              }\n                              topLevelMediaType {\n                                kind\n                                id\n                              }\n                            }\n                            kind\n                            link\n                          }\n                        }\n                      }\n                    }\n                    entities {\n                      id\n                      name\n                      description\n                      landingPageUrl\n                      previews {\n                        count\n                        edges {\n                          cursor\n                          preview {\n                            mediaAsset {\n                              id\n                              files {\n                                id\n                                name\n                                heightInPixels\n                                widthInPixels\n                                path\n                                status {\n                                  kind\n                                  id\n                                }\n                              }\n                              state {\n                                kind\n                                id\n                              }\n                              topLevelMediaType {\n                                kind\n                                id\n                              }\n                            }\n                            kind\n                            link\n                          }\n                        }\n                      }\n                    }\n                    peopleEntities {\n                      entity {\n                        __typename\n                        landingPageUrl\n                        id\n                        name\n                        websiteUrl\n                        industry\n                        fundingRound\n                        activities {\n                          kind\n                          label\n                          id\n                        }\n                        people {\n                          count\n                          edges {\n                            role\n                            person {\n                              __typename\n                              id\n                              fullName\n                              landingPageUrl\n                              previews {\n                                edges {\n                                  preview {\n                                    link\n                                    kind\n                                    mediaAsset {\n                                      files {\n                                        name\n                                        path\n                                        id\n                                      }\n                                      topLevelMediaType {\n                                        kind\n                                        id\n                                      }\n                                      id\n                                    }\n                                  }\n                                }\n                              }\n                            }\n                          }\n                        }\n                        investmentsBy {\n                          amount\n                          link\n                          deckUrl\n                          investmentDate\n                          id\n                        }\n                        previews {\n                          count\n                          edges {\n                            cursor\n                            preview {\n                              mediaAsset {\n                                id\n                                files {\n                                  id\n                                  name\n                                  heightInPixels\n                                  widthInPixels\n                                  path\n                                  status {\n                                    kind\n                                    id\n                                  }\n                                }\n                                state {\n                                  kind\n                                  id\n                                }\n                                topLevelMediaType {\n                                  kind\n                                  id\n                                }\n                              }\n                              kind\n                              link\n                            }\n                          }\n                        }\n                      }\n                      person {\n                        __typename\n                        landingPageUrl\n                        id\n                        fullName\n                        responsibility\n                        description\n                        previews {\n                          count\n                          edges {\n                            cursor\n                            preview {\n                              mediaAsset {\n                                id\n                                files {\n                                  id\n                                  name\n                                  heightInPixels\n                                  widthInPixels\n                                  path\n                                  status {\n                                    kind\n                                    id\n                                  }\n                                }\n                                state {\n                                  kind\n                                  id\n                                }\n                                topLevelMediaType {\n                                  kind\n                                  id\n                                }\n                              }\n                              kind\n                              link\n                            }\n                          }\n                        }\n                      }\n                    }\n                    summary\n                    url\n                  }\n                  ... on PitchVideoStory {\n                    __typename\n                    id\n                    title\n                    description\n                    subTitle\n                    isPromoted\n                    trailer {\n                      externalId\n                      description\n                      durationInSeconds\n                      link\n                    }\n                    originalClip {\n                      externalId\n                      durationInSeconds\n                      description\n                      link\n                    }\n                    label\n                    peopleEntities {\n                      entity {\n                        __typename\n                        landingPageUrl\n                        id\n                        name\n                        websiteUrl\n                        industry\n                        fundingRound\n                        activities {\n                          kind\n                          label\n                          id\n                        }\n                        people {\n                          count\n                          edges {\n                            role\n                            person {\n                              __typename\n                              id\n                              fullName\n                              landingPageUrl\n                              previews {\n                                edges {\n                                  preview {\n                                    link\n                                    kind\n                                    mediaAsset {\n                                      files {\n                                        name\n                                        path\n                                        id\n                                      }\n                                      topLevelMediaType {\n                                        kind\n                                        id\n                                      }\n                                      id\n                                    }\n                                  }\n                                }\n                              }\n                            }\n                          }\n                        }\n                        investmentsBy {\n                          amount\n                          link\n                          deckUrl\n                          investmentDate\n                          id\n                        }\n                        previews {\n                          count\n                          edges {\n                            cursor\n                            preview {\n                              mediaAsset {\n                                id\n                                files {\n                                  id\n                                  name\n                                  heightInPixels\n                                  widthInPixels\n                                  path\n                                  status {\n                                    kind\n                                    id\n                                  }\n                                }\n                                state {\n                                  kind\n                                  id\n                                }\n                                topLevelMediaType {\n                                  kind\n                                  id\n                                }\n                              }\n                              kind\n                              link\n                            }\n                          }\n                        }\n                      }\n                      person {\n                        __typename\n                        landingPageUrl\n                        id\n                        fullName\n                        responsibility\n                        description\n                        previews {\n                          count\n                          edges {\n                            cursor\n                            preview {\n                              mediaAsset {\n                                id\n                                files {\n                                  id\n                                  name\n                                  heightInPixels\n                                  widthInPixels\n                                  path\n                                  status {\n                                    kind\n                                    id\n                                  }\n                                }\n                                state {\n                                  kind\n                                  id\n                                }\n                                topLevelMediaType {\n                                  kind\n                                  id\n                                }\n                              }\n                              kind\n                              link\n                            }\n                          }\n                        }\n                      }\n                    }\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                    revision\n                  }\n                  ... on OriginalContentStory {\n                    __typename\n                    id\n                    revision\n                    landingPageUrl\n                    sourceList\n                    durationInSeconds\n                    description\n                    externalId\n                    subTitle\n                    title\n                    label\n                    link\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                  }\n                  ... on PodcastStory {\n                    __typename\n                    description\n                    durationInSeconds\n                    id\n                    title\n                    subTitle\n                    link\n                    publisher\n                    landingPageUrl\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                    revision\n                  }\n                  ... on Poster {\n                    __typename\n                    actionDescription\n                    actionTitle\n                    description\n                    permalink\n                    id\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                    subTitle\n                    title\n                    revision\n                  }\n                  ... on Entity {\n                    __typename\n                    description\n                    hasPublicPage\n                    id\n                    name\n                    landingPageUrl\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                  }\n                  ... on Person {\n                    __typename\n                    hasPublicPage\n                    id\n                    fullName\n                    landingPageUrl\n                    description\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                    responsibility\n                  }\n                  ... on ArticleStory {\n                    __typename\n                    description\n                    id\n                    link\n                    subTitle\n                    title\n                    publisher\n                    publishedDate\n                    timeToReadInSeconds\n                    revision\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                  }\n                  ... on BookStory {\n                    __typename\n                    description\n                    id\n                    link\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                    subTitle\n                    title\n                  }\n                  ... on NewsletterStory {\n                    __typename\n                    description\n                    link\n                    id\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                    subTitle\n                    title\n                    publisher\n                    publishedDate\n                    timeToReadInSeconds\n                  }\n                  ... on OnlineCourseStory {\n                    __typename\n                    description\n                    id\n                    link\n                    cost\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                    subTitle\n                    title\n                    publishedDate\n                    timeRequiredInSeconds\n                    publisher\n                    revision\n                  }\n                  ... on Node {\n                    id\n                  }\n                  ... on SearchHit {\n                    id\n                  }\n                  ... on Tag {\n                    id\n                  }\n                }\n                id\n              }\n            }\n          }\n          label\n          name\n          previews {\n            count\n            edges {\n              cursor\n              preview {\n                mediaAsset {\n                  id\n                  files {\n                    id\n                    name\n                    heightInPixels\n                    widthInPixels\n                    path\n                    status {\n                      kind\n                      id\n                    }\n                  }\n                  state {\n                    kind\n                    id\n                  }\n                  topLevelMediaType {\n                    kind\n                    id\n                  }\n                }\n                kind\n                link\n              }\n            }\n          }\n          subTitle\n          title\n          revision\n        }\n        ... on DynamicList {\n          description\n          id\n          label\n          name\n          items(first: $count) {\n            edges {\n              listItem {\n                item {\n                  __typename\n                  ... on SearchHit {\n                    __typename\n                    id\n                    kind\n                    label\n                    linkUrl\n                    name\n                    previewUrl\n                    publisher\n                    landingPageUrl\n                    responsibility\n                    subTitle\n                    title\n                    tags\n                  }\n                  ... on Node {\n                    id\n                  }\n                  ... on Tag {\n                    id\n                  }\n                }\n                id\n              }\n            }\n          }\n          previews {\n            count\n            edges {\n              cursor\n              preview {\n                mediaAsset {\n                  id\n                  files {\n                    id\n                    name\n                    heightInPixels\n                    widthInPixels\n                    path\n                    status {\n                      kind\n                      id\n                    }\n                  }\n                  state {\n                    kind\n                    id\n                  }\n                  topLevelMediaType {\n                    kind\n                    id\n                  }\n                }\n                kind\n                link\n              }\n            }\n          }\n          subTitle\n          title\n          revision\n        }\n        ... on Node {\n          id\n        }\n      }\n      previews {\n        count\n        edges {\n          cursor\n          preview {\n            mediaAsset {\n              id\n              files {\n                id\n                name\n                heightInPixels\n                widthInPixels\n                path\n                status {\n                  kind\n                  id\n                }\n              }\n              state {\n                kind\n                id\n              }\n              topLevelMediaType {\n                kind\n                id\n              }\n            }\n            kind\n            link\n          }\n        }\n      }\n      name\n      subTitle\n      title\n      revision\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '20cbdbd0dde351a65629e9b2ae5bc8d4';
export default node;
